import { render, staticRenderFns } from "./AtomButtonSecondary.vue?vue&type=template&id=f2afcf96"
import script from "./AtomButtonSecondary.vue?vue&type=script&lang=js"
export * from "./AtomButtonSecondary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports